import {
  Box,
  Button,
  HStack,
  Input,
  Spinner,
  Stack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getOrganisations,
  searchOrganisations,
} from '../../../stores/slices/organisations/organisationsActions';
import OrganisationModal from './OrganisationModal';
import OrganisationsList from './OrganisationsList';

const Organisations = () => {
  const { organisations, isLoading } = useSelector(
    state => state.organisations
  );

  const [toUpdate, setToUpdate] = useState({
    state: false,
    organisation: null,
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchTerm, setSearchTerm] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrganisations());
  }, []);

  const onCloseModal = () => {
    onClose();
    setToUpdate({ state: false, organisation: null });
  };

  const searchOrg = () => {
    dispatch(searchOrganisations({ val: searchTerm }));
  };
  return (
    <React.Fragment>
      <Box w={'full'} overflowX={'hidden'} overflowY={'auto'}>
        <VStack spacing={'4'}>
          <Stack
            justifyContent={'space-between'}
            alignContent={'center'}
            direction={{ base: 'column', sm: 'row' }}
            w={'full'}
            spacing={4}
            pr={'2'}
            pb={'2'}
            zIndex={'20'}
            sx={{
              position: '-webkit-sticky',
              /* Safari */
              position: 'sticky',
              top: '0',
            }}
            bg={'white'}
            borderBottom={'1px'}
            borderColor={'gray.500'}
          >
            <HStack>
              <Input
                size={'sm'}
                pr="4.5rem"
                placeholder="Search"
                borderRadius={'4'}
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
              <Button size={'sm'} onClick={searchOrg}>
                Search
              </Button>

              {searchTerm !== '' && (
                <Button
                  variant={'outline'}
                  size={'sm'}
                  onClick={() => {
                    setSearchTerm('');
                    dispatch(getOrganisations());
                  }}
                >
                  Clear
                </Button>
              )}
            </HStack>
            <Button size={'sm'} onClick={onOpen}>
              Add Organisation
            </Button>
          </Stack>
          <Box
            overflowX={'auto'}
            w={'full'}
            flex={'1'}
            flexGrow={'1'}
            h={'full'}
          >
            {isLoading ? (
              <Spinner color="primary" />
            ) : organisations.length > 0 ? (
              <OrganisationsList />
            ) : (
              <Text fontWeight={'bold'} textAlign={'center'}>
                No organisation found. Please{' '}
                <Button variant="link" color={'primary'} onClick={onOpen}>
                  create
                </Button>{' '}
                a new one.
              </Text>
            )}
          </Box>
        </VStack>
      </Box>
      {isOpen && (
        <OrganisationModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onCloseModal}
          toUpdate={toUpdate}
        />
      )}
    </React.Fragment>
  );
};

export default Organisations;
